import { createAction } from 'redux-actions-helpers'
import { ModuleType } from './types'

export const fetchModulesList = createAction(
  '@@admin-modules-list/FETCH_MODULES_LIST',
  (id: string): any => ({ id })
)

export const fetchModulesListSuccess = createAction(
  '@@admin-modules-list/FETCH_MODULES_LIST_SUCCESS',
  (result: ModuleType[]): any => ({ result })
)

export const fetchModulesListFailure = createAction(
  '@@admin-modules-list/FETCH_MODULES_LIST_FAILURE',
  (error: string): any => ({ error })
)

export const createModuleRelation = createAction(
  '@@admin-modules-list/CREATE_MODULE_RELATION',
  (
    id: string,
    sourceId: string,
    targetId: string,
    relationType: string
  ): any => ({
    id,
    sourceId,
    targetId,
    relationType,
  })
)

export const createModuleRelationSuccess = createAction(
  '@@admin-modules-list/CREATE_MODULE_RELATION_SUCCESS'
)

export const createModuleRelationFailure = createAction(
  '@@admin-modules-list/CREATE_MODULE_RELATION_FAILURE',
  (error: string): any => ({ error })
)

export const editModuleRelation = createAction(
  '@@admin-modules-list/EDIT_MODULE_RELATION',
  (
    id: string,
    relationId: string,
    sourceId: string,
    targetId: string,
    relationType: string
  ): any => ({
    id,
    relationId,
    sourceId,
    targetId,
    relationType,
  })
)

export const editModuleRelationSuccess = createAction(
  '@@admin-modules-list/EDIT_MODULE_RELATION_SUCCESS'
)

export const editModuleRelationFailure = createAction(
  '@@admin-modules-list/EDIT_MODULE_RELATION_FAILURE',
  (error: string): any => ({ error })
)

export const removeModule = createAction(
  '@@admin-modules-list/REMOVE_MODULE',
  (id: string, mid: string): any => ({ id, mid })
)

export const removeModuleSuccess = createAction(
  '@@admin-modules-list/REMOVE_MODULE_SUCCESS'
)

export const removeModuleFailure = createAction(
  '@@admin-modules-list/REMOVE_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const removeModuleRelation = createAction(
  '@@admin-modules-list/REMOVE_MODULE_RELATION',
  (id: string, mid: string): any => ({ id, mid })
)

export const removeModuleRelationSuccess = createAction(
  '@@admin-modules-list/REMOVE_MODULE_RELATION_SUCCESS',
  (result: any): any => ({ result })
)

export const removeModuleRelationFailure = createAction(
  '@@admin-modules-list/REMOVE_MODULE_RELATION_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-modules-list/DESTROY')
